/**
 * Template: Product
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
import { load } from '@shopify/theme-sections';
import ProductForm from '~/components/product-form';
import ProductGallery from '~/components/product-gallery';
import VideoPlayer from '~/components/video-player';
import Modal from '~/components/modal';
import cssClasses from '~/helpers/cssClasses';
import { on } from '~/helpers/utils';
import '~/sections/recommended-prods';
import '~/sections/product-yotpo';
const namespace = 'expert';
const modal = Modal({
  id: namespace
});
const selectors = {
  expert: '[js-care-guide="modal"]',
  close: '[js-modal="closeModal"]',
  careGuide: '[js-product-gallery="care_guide"]',
  careGuideContainer: '[js-care-guide="container"]',
  stars: '[js-product-form="stars"]',
  reviews: '[js-product-reviews="container"]',
  gallery: '[js-product-gallery="featuredCarousel"]',
  badge: '[js-product-gallery="badge"]'
};
const nodeSelectors = {
  expert: document.querySelector(selectors.expert),
  close: document.querySelector(selectors.close),
  careGuide: document.querySelector(selectors.careGuide),
  careGuideContainer: document.querySelector(selectors.careGuideContainer),
  stars: document.querySelector(selectors.stars),
  reviews: document.querySelector(selectors.reviews),
  gallery: document.querySelector(selectors.gallery),
  badge: document.querySelector(selectors.badge)
};

function disableGallery() {
  nodeSelectors.gallery.classList.add(cssClasses.disabled);
}

function enableGallery(variant) {
  if (variant.available) {
    nodeSelectors.gallery.classList.remove(cssClasses.disabled);
  }

  return false;
}

function enableBadge() {
  if (!nodeSelectors.badge) {
    return false;
  }

  nodeSelectors.badge.classList.remove(cssClasses.hidden);
  return false;
}

function disableBadge() {
  if (!nodeSelectors.badge) {
    return false;
  }

  nodeSelectors.badge.classList.add(cssClasses.hidden);
  return false;
}

function setEventBusListeners() {
  Frame.EventBus.listen('ProductSwatches:soldOut', response => disableGallery(response));
  Frame.EventBus.listen('Variant:isAvailable', variant => enableGallery(variant));
  Frame.EventBus.listen('Badge:enable', () => enableBadge());
  Frame.EventBus.listen('Badge:disable', () => disableBadge());
}

function setEventListeners() {
  if (nodeSelectors.expert) {
    on('click', nodeSelectors.expert, event => {
      event.preventDefault();
      modal.show(namespace);
      VideoPlayer().init();
    });
  }

  on('click', nodeSelectors.close, event => {
    event.preventDefault();
    modal.close(namespace);
  });
  on('click', nodeSelectors.careGuide, event => {
    event.preventDefault();
    nodeSelectors.careGuideContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  });

  if (nodeSelectors.stars) {
    on('click', nodeSelectors.stars, event => {
      event.preventDefault();
      nodeSelectors.reviews.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  load('recommended-products');
  modal.init();
  ProductForm({
    container: 'container',
    enableSwatches: true,
    enableHistoryState: true
  }).init();
  ProductGallery().init();
  setEventListeners();
  setEventBusListeners();
});